var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Help } from '@mui/icons-material';
import { Box, Button, Tooltip } from '@mui/material';
import { useRequest } from '../../hooks/requestHook';
import { typicaStockItem as api } from '../../api';
import { column, numericColumn, datetimeColumn, } from '../../hooks/useColumns';
import MaterialTable from '../MaterialTable';
import PageLayout from '../atoms/PageLayout';
import useFetch from '../../hooks/useFetch';
import { decamelize } from '../../utils/camelize';
import qs from 'qs';
import { Link, useLocation } from 'react-router-dom';
import { useNotify } from '../../hooks/notificationHook';
import { weightFormat } from '../../utils/format';
import NumericTextField from '../MaterialTable/NumericTextField';
import EditDateTimePicker from '../MaterialTable/EditDateTimePicker';
import DateRangeFilter from '../molecules/DateRangeFilter';
import { endOfDay, startOfDay } from 'date-fns';
import StockFilter from '../molecules/StockFilter';
import { useOffice } from '../../hooks/useOffice';
import { toOptions } from '../../hooks/useListItem';
import DownloadButton from '../molecules/DownloadButton';
var AdminTypicaStockItemsPage = function () {
    var t = useTranslation().t;
    var location = useLocation();
    var urlQuery = qs.parse(location.search.slice(1));
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var orderBy = urlQuery.orderBy;
    var orderDirection = urlQuery.orderDirection;
    var updateApi = useRequest(api.update);
    var notify = useNotify();
    var officeListItems = useOffice().officeListItems;
    var buildFilterParams = React.useCallback(function (query) {
        var q = { with_ordered_quantity: true };
        query.filters.forEach(function (filter) {
            if (!filter.column.field)
                return;
            switch (filter.column.field) {
                case 'remainingQuantity':
                    if (filter.value == 'inStock')
                        q.remaining = true;
                    break;
                case 'importedAt':
                case 'exportedAt':
                case 'createdAt': {
                    var field = decamelize(filter.column.field);
                    if (filter.value.startedAt) {
                        q["".concat(field, "_gteq")] = startOfDay(new Date(filter.value.startedAt));
                    }
                    if (filter.value.endedAt) {
                        q["".concat(field, "_lteq")] = endOfDay(new Date(filter.value.endedAt));
                    }
                    break;
                }
                case 'warehouse.office.id':
                    q['with_office'] = filter.value;
                    break;
                default: {
                    var field = filter.column.field
                        .split('.')
                        .map(function (e) { return decamelize(e); })
                        .join('_');
                    q["".concat(field, "_cont")] = filter.value;
                    break;
                }
            }
        });
        return q;
    }, []);
    var buildOrder = React.useCallback(function (field) {
        switch (field) {
            case 'offer.offerList.name':
                return 'offer_lists.name';
            case 'offer.lotNumber':
                return 'offers.lot_number';
            case 'warehouse.name':
                return 'warehouses.name';
            default:
                return decamelize(field);
        }
    }, []);
    var fetchTypicaStockItems = useFetch({
        buildFilterParams: buildFilterParams,
        buildOrder: buildOrder,
        api: useRequest(api.getAll),
    });
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        return filters[field];
    }, [urlQuery]);
    var defaultSort = React.useCallback(function (field) {
        if (orderBy === field &&
            (orderDirection === 'asc' || orderDirection === 'desc')) {
            return orderDirection;
        }
        return;
    }, [orderBy, orderDirection]);
    var renderOfferListLink = React.useCallback(function (_a) {
        var _b = _a.offer.offerList, id = _b.id, name = _b.name;
        return React.createElement(Link, { to: "/admin/offer_lists/".concat(id) }, name);
    }, []);
    var renderMinOrder = React.useCallback(function (_a) {
        var minOrder = _a.minOrder, bagSize = _a.bagSize;
        return "".concat(weightFormat(minOrder), " / ").concat(weightFormat(bagSize));
    }, []);
    var handleUpdate = React.useCallback(function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateApi({
                        id: item.id,
                        typica_stock_item: {
                            quantity: item.quantity,
                            adjustment_quantity: item.adjustmentQuantity,
                            sample_quantity: item.sampleQuantity,
                            imported_at: item.importedAt,
                            exported_at: item.exportedAt,
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        throw Error('response error');
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, notify, updateApi]);
    var renderEditAdjustmentQuantity = React.useCallback(function (props) { return React.createElement(NumericTextField, __assign({}, props)); }, []);
    var renderDateRangeFilter = React.useCallback(function (props) { return React.createElement(DateRangeFilter, __assign({}, props)); }, []);
    var renderStockFilter = React.useCallback(function (props) { return React.createElement(StockFilter, __assign({}, props)); }, []);
    var columns = React.useMemo(function () { return [
        column('offer.offerList.name', {
            title: t('params.offerList.name'),
            defaultFilter: defaultFilter('offer.offerList.name'),
            defaultSort: defaultSort('offer.offerList.name'),
            render: renderOfferListLink,
            editable: 'never',
        }),
        column('offer.lotNumber', {
            title: t('params.offer.lotNumber'),
            defaultFilter: defaultFilter('offer.lotNumber'),
            defaultSort: defaultSort('offer.lotNumber'),
            editable: 'never',
            cellStyle: {
                whiteSpace: 'nowrap',
            },
        }),
        column('warehouse.name', {
            title: t('params.warehouse.name'),
            defaultFilter: defaultFilter('warehouse.name'),
            defaultSort: defaultSort('warehouse.name'),
            editable: 'never',
        }),
        column('warehouse.office.id', {
            title: t('params.office.name'),
            defaultFilter: defaultFilter('warehouse.office.id'),
            lookup: toOptions(officeListItems),
            sorting: false,
            editable: 'never',
        }),
        numericColumn('minOrder', {
            title: t('params.typicaStockItem.minOrder'),
            filtering: false,
            defaultSort: defaultSort('minOrder'),
            editable: 'never',
            render: renderMinOrder,
        }),
        numericColumn('quantity', {
            title: (React.createElement(React.Fragment, null,
                React.createElement(HelpIcon, { help: t('pages.adminTypicaStockItems.helpQuantity') }),
                t('params.typicaStockItem.quantity'))),
            filtering: false,
            defaultSort: defaultSort('quantity'),
        }),
        numericColumn('orderedQuantity', {
            title: t('params.typicaStockItem.orderedQuantity'),
            filtering: false,
            defaultSort: defaultSort('orderedQuantity'),
            editable: 'never',
        }),
        numericColumn('remainingQuantity', {
            title: (React.createElement(React.Fragment, null,
                React.createElement(HelpIcon, { help: t('pages.adminTypicaStockItems.helpRemainingQuantity') }),
                t('params.typicaStockItem.remainingQuantity'))),
            filtering: true,
            defaultFilter: defaultFilter('remainingQuantity'),
            filterComponent: renderStockFilter,
            defaultSort: defaultSort('remainingQuantity'),
            editable: 'never',
        }),
        numericColumn('adjustmentQuantity', {
            title: (React.createElement(React.Fragment, null,
                React.createElement(HelpIcon, { help: t('pages.adminTypicaStockItems.helpAdjustmentQuantity') }),
                t('params.typicaStockItem.adjustmentQuantity'))),
            filtering: false,
            editComponent: renderEditAdjustmentQuantity,
            defaultSort: defaultSort('adjustmentQuantity'),
        }),
        numericColumn('sampleQuantity', {
            title: t('params.typicaStockItem.sampleQuantity'),
            filtering: false,
            defaultSort: defaultSort('sampleQuantity'),
        }),
        numericColumn('sampleOrderedQuantity', {
            title: t('params.typicaStockItem.sampleOrderedQuantity'),
            filtering: false,
            editable: 'never',
            defaultSort: defaultSort('sampleOrderedQuantity'),
        }),
        numericColumn('sampleRemainingQuantity', {
            title: (React.createElement(React.Fragment, null,
                React.createElement(HelpIcon, { help: t('pages.adminTypicaStockItems.helpSampleRemainingQuantity') }),
                t('params.typicaStockItem.sampleRemainingQuantity'))),
            filtering: false,
            editable: 'never',
            defaultSort: defaultSort('sampleRemainingQuantity'),
        }),
        datetimeColumn('exportedAt', {
            title: t('params.exportedAt'),
            filtering: true,
            defaultFilter: defaultFilter('exportedAt'),
            defaultSort: defaultSort('exportedAt'),
            filterComponent: renderDateRangeFilter,
            editComponent: EditDateTimePicker,
        }),
        datetimeColumn('importedAt', {
            title: t('params.importedAt'),
            filtering: true,
            defaultFilter: defaultFilter('importedAt'),
            defaultSort: defaultSort('importedAt'),
            filterComponent: renderDateRangeFilter,
            editComponent: EditDateTimePicker,
        }),
        datetimeColumn('createdAt', {
            title: t('params.createdAt'),
            filtering: true,
            defaultFilter: defaultFilter('createdAt'),
            defaultSort: defaultSort('createdAt'),
            filterComponent: renderDateRangeFilter,
            editable: 'never',
        }),
    ]; }, [
        t,
        defaultFilter,
        defaultSort,
        renderOfferListLink,
        renderMinOrder,
        renderEditAdjustmentQuantity,
        renderDateRangeFilter,
        renderStockFilter,
        officeListItems,
    ]);
    var csvParams = React.useMemo(function () {
        if (!urlQuery.filters)
            return;
        var filters = Object.entries(urlQuery.filters).map(function (_a) {
            var field = _a[0], value = _a[1];
            return ({
                column: { field: field },
                operator: '=',
                value: value,
            });
        });
        return { q: buildFilterParams({ filters: filters }) };
    }, [urlQuery.filters, buildFilterParams]);
    return (React.createElement(PageLayout, { title: t('pages.adminTypicaStockItems.title'), actions: React.createElement(Box, null,
            React.createElement(DownloadButton, { key: JSON.stringify(csvParams), size: "medium", path: "/api/typica_stock_items/export", downloadFilename: "typica_stock_items.csv", withDownloadTimestamp: true, params: csvParams }),
            React.createElement(Button, { variant: "contained", component: Link, to: "/admin/new_typica_stock_order", sx: {
                    marginLeft: 1,
                } }, t('pages.adminNewTypicaStockOrder.title'))) },
        React.createElement(MaterialTable, { model: "typicaStockItem", columns: columns, data: fetchTypicaStockItems, editable: {
                onRowUpdate: handleUpdate,
            }, options: {
                filtering: true,
                paging: true,
                initialPage: initialPage,
                pageSize: pageSize,
            } })));
};
export default AdminTypicaStockItemsPage;
var HelpIconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  svg {\n    font-size: 16px;\n  }\n"], ["\n  svg {\n    font-size: 16px;\n  }\n"])));
var HelpIcon = function (_a) {
    var help = _a.help;
    return (React.createElement(HelpIconWrapper, null,
        React.createElement(Tooltip, { title: help, placement: "top" },
            React.createElement(Help, null))));
};
var templateObject_1;
